<div class="ww-card" [class.ww-card-dynamic]="!!dynamic">
  <!-- the palette builder: the same header, generators, tiles and editor as the palette tool -->
  <app-palette-widget
    class="ww-palette"
    [studio]="true"
    [title]="cardTitle"
    [palette]="palette"
    [subtitle]="subtitle"
    [scheme]="scheme"
    [count]="count"
    (countChange)="countChange.emit( $event )"
    [defaultMin]="GRADIENT_SCHEME_MINS.defaultMin"
    [schemeMins]="GRADIENT_SCHEME_MINS.schemeMins"
    (editColor)="onEditColor( $event )"
    (reorder)="reorder.emit( $event )"
    (addColor)="addColor.emit()"
    (removeColor)="removeColor.emit( $event )"
    (reverse)="reverse.emit()"
    (generate)="generate.emit( $event )"
    (uploadImage)="uploadImage.emit( $event )">
  </app-palette-widget>

  <!-- the picture's controls: the style (in the tray) and its two fields -->
  <div class="ww-panel">
    <!-- the style as the generator picker (owner 2026-10-12): each style a small picture of it in your colors,
         with a line on what it draws -->
    <div class="ww-field ww-area-style ws-pick ws-pick-style">
      <span class="ps-label">Style</span>
      <button type="button" class="ps-gen-btn" [class.open]="styleOpen" (click)="toggleStyle( $any( $event.currentTarget ) )"
              aria-haspopup="dialog" [attr.aria-expanded]="styleOpen">
        <span class="ws-thumb"><img [src]="thumbs[ style ]" alt="" aria-hidden="true" width="46" height="26" decoding="async"/></span>
        <span class="ps-gen-text">
          <span class="ps-gen-name">{{ styleLabel }}</span>
          <span class="ps-gen-desc">{{ styleInfo.blurb }}</span>
        </span>
        <app-icon class="ps-gen-caret" name="chevron-right" aria-hidden="true"></app-icon>
      </button>
      <div class="ps-gen-pop" *ngIf="styleOpen" role="dialog" aria-label="Styles" [style.max-height.px]="styleMaxHeight" (click)="$event.stopPropagation()">
        <button type="button" class="ps-gen-opt" *ngFor="let s of styles" [class.on]="s.key === style" (click)="pickStyle( s.key )">
          <span class="ws-thumb"><img [src]="thumbs[ s.key ]" alt="" aria-hidden="true" width="46" height="26" loading="lazy" decoding="async"/></span>
          <span class="ps-gen-text">
            <span class="ps-gen-name">{{ s.label }}</span>
            <span class="ps-gen-desc">{{ s.blurb }}</span>
          </span>
        </button>
      </div>
    </div>

    <!-- the style's two fields, beside the selected colour -->
    <div class="ww-field" *ngFor="let prm of styleInfo.params; index as i" [class.ww-area-p1]="i === 0" [class.ww-area-p2]="i === 1">
      <span class="ww-flabel">{{ prm.label }}</span>
      <div class="ww-control">
        <label class="ww-inputwrap">
          <input #pv type="text" class="ww-input"
                 [value]="params[ i ]"
                 (input)="onParamInput( i, $any( $event.target ) )"
                 (keydown.enter)="pv.blur()"
                 (blur)="commitParam( i, pv.value ); pv.value = params[ i ]"
                 inputmode="numeric" maxlength="3" [attr.aria-label]="styleInfo.label + ' ' + prm.label + ', 0 to ' + prm.max"/>
          <span class="ww-input-unit" aria-hidden="true">{{ prm.unit }}</span>
        </label>
      </div>
    </div>

    <!-- the dynamic wallpaper's day (its page only): how it changes, the frames, the night and the glow -->
    <ng-container *ngIf="dynamic">
      <div class="ww-field ww-area-mode ws-pick ws-pick-mode">
        <span class="ps-label">Changes By</span>
        <button type="button" class="ps-gen-btn" [class.open]="modeOpen" (click)="toggleMode( $any( $event.currentTarget ) )"
                aria-haspopup="dialog" [attr.aria-expanded]="modeOpen">
          <span class="ws-mode-icon"><app-icon [name]="modeIcon( dynamic.mode )" aria-hidden="true"></app-icon></span>
          <span class="ps-gen-text">
            <span class="ps-gen-name">{{ modeInfo?.label }}</span>
            <span class="ps-gen-desc">{{ modeInfo?.blurb }}</span>
          </span>
          <app-icon class="ps-gen-caret" name="chevron-right" aria-hidden="true"></app-icon>
        </button>
        <div class="ps-gen-pop" *ngIf="modeOpen" role="dialog" aria-label="How the wallpaper changes" [style.max-height.px]="styleMaxHeight" (click)="$event.stopPropagation()">
          <button type="button" class="ps-gen-opt" *ngFor="let m of dynamicModes" [class.on]="m.key === dynamic.mode" (click)="pickMode( m.key )">
            <span class="ws-mode-icon"><app-icon [name]="modeIcon( m.key )" aria-hidden="true"></app-icon></span>
            <span class="ps-gen-text">
              <span class="ps-gen-name">{{ m.label }}</span>
              <span class="ps-gen-desc">{{ m.blurb }}</span>
            </span>
          </button>
        </div>
      </div>

      <div class="ww-field ww-area-frames">
        <span class="ww-flabel">Frames</span>
        <div class="ww-control">
          <app-cg-select *ngIf="dynamic.mode !== 'appearance'" class="ww-select" [options]="frameOptions" [value]="'' + dynamic.frames"
                         (valueChange)="onFrames( $event )" ariaLabel="Frames through the day"></app-cg-select>
          <span *ngIf="dynamic.mode === 'appearance'" class="ww-input ww-static">2 frames · Light and Dark</span>
        </div>
      </div>

      <div class="ww-field ww-area-night">
        <span class="ww-flabel">Night</span>
        <div class="ww-control">
          <label class="ww-inputwrap">
            <input #nv type="text" class="ww-input" [value]="dynamic.night" inputmode="numeric" maxlength="3"
                   (keydown.enter)="nv.blur()" (blur)="commitLight( 'night', nv.value ); nv.value = '' + dynamic.night"
                   aria-label="How dark the night gets, 0 to 100"/>
            <span class="ww-input-unit" aria-hidden="true">/ 100</span>
          </label>
        </div>
      </div>

      <div class="ww-field ww-area-glow">
        <span class="ww-flabel">Glow</span>
        <div class="ww-control">
          <label class="ww-inputwrap">
            <input #gv type="text" class="ww-input" [value]="dynamic.glow" inputmode="numeric" maxlength="3"
                   (keydown.enter)="gv.blur()" (blur)="commitLight( 'glow', gv.value ); gv.value = '' + dynamic.glow"
                   aria-label="How warm sunrise and sunset glow, 0 to 100"/>
            <span class="ww-input-unit" aria-hidden="true">/ 100</span>
          </label>
        </div>
      </div>
    </ng-container>

    <!-- a mini preview, always the 1920 × 1080 framing, the right half, both rows -->
    <button type="button" class="ww-mini ww-area-mini" (click)="zoomed = true" aria-label="Open the preview large">
      <img *ngIf="shownPreview" [src]="shownPreview" [alt]="styleLabel + ' wallpaper, small preview'" decoding="async">
      <span class="ww-loading" *ngIf="previewLoading"><app-codigrate-loader [scale]="1.2" label="Drawing the wallpaper"></app-codigrate-loader></span>
      <span class="ww-mini-badge">Preview</span>
    </button>
  </div>

  <!-- the preview large, over the page (owner 2026-10-12); a click or Escape closes it -->
  <div class="tool-zoom" appToBody *ngIf="zoomed" role="dialog" aria-label="Wallpaper preview" (click)="zoomed = false">
    <img class="tool-zoom-pic" *ngIf="shownPreview" [src]="shownPreview" [alt]="styleLabel + ' wallpaper'"/>
    <button type="button" class="tool-zoom-close" aria-label="Close the preview"><app-icon name="times" aria-hidden="true"></app-icon></button>
  </div>

  <!-- the picture is drawn here off screen; the host paints it (the hero backdrop, the Preview section) -->
  <canvas #canvas class="ww-canvas" aria-hidden="true"></canvas>
</div>

<!-- Home page: a read-more style CTA to the full wallpaper tool. -->
<div *ngIf="showDetailsCta" class="ww-cta-row">
  <a class="codigrate-button" [routerLink]="detailsRoute" [queryParams]="detailsQueryParams" (click)="detailsClick.emit()">
    <app-arrow-right [height]="16"></app-arrow-right>
    <p>Open Full Wallpaper Tool</p>
  </a>
</div>
